import React from 'react';
import { useLocation } from 'react-router-dom';
import { RightRail } from '../../components';

import { stringFormatter } from '@nhl/formatter-utilities';

const withRightRail = (WrappedComponent) => {

    const Wrapper = (props) => {
        const location = useLocation();

        return (
            <div className={`with-right-rail ${stringFormatter.toSlug(location.pathname)}`}>
                <WrappedComponent {...props} />
                <RightRail />
            </div>
        );
    };

    return React.memo(Wrapper);
};

export default withRightRail;